import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypePers } from '../models/TypePers';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/divers/step1';
import {AutoCompleteService} from '../../../../shared/services/auto-complete.service';

@Component({
  selector: 'app-type-pers',
  templateUrl: './type-pers.component.html'
})
export class TypePersComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypePers';
  @Input() parentForm: FormGroup;
  @Input() correspondantPRM: TypePers;
  @Input() disabled: boolean;
  @Input() rule: String;

  public optionsSelect: any[];
  public optionsSelectType = 'CIVILITE';
  public step1 = new Step1();

  constructor(private autoCompleteService: AutoCompleteService) {
  }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);

    if(!this.correspondantPRM) {
      this.correspondantPRM = new TypePers();
    }

    if (this.correspondantPRM.civilite === null) {
      this.correspondantPRM.civilite = '';
    }
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
